import { AppEnvironment } from '../app/config/environment.token';

export const environment: AppEnvironment = {
  apiUrl: 'https://api-dev.billtracker.cloud',
  production: true
};